export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["II"] = "Internet Identity";
    AuthProvider["EMAIL"] = "Email";
    AuthProvider["ETH"] = "Ethereum";
    AuthProvider["SOL"] = "Solana";
    AuthProvider["NFID"] = "Google via NFID";
    AuthProvider["PASSKEY"] = "Passkey";
})(AuthProvider || (AuthProvider = {}));
export class InMemoryAuthClientStorage {
    _map;
    constructor() {
        this._map = new Map();
    }
    get(key) {
        return Promise.resolve(this._map.get(key) ?? null);
    }
    set(key, value) {
        this._map.set(key, value);
        return Promise.resolve();
    }
    remove(key) {
        this._map.delete(key);
        return Promise.resolve();
    }
}
